import React from "react";
import { Link } from "react-router-dom"; // ✅ import Link for routing

const Asidde = () => {
  return (
       <div className="mini-sidebar d-flex align-items-center flex-column justify-content-between">
          <div className="user">
            <img
              src="/assets/images/logo1.png"
              className="mb-4 mt-5 text-center"
              width="90"
              alt="Logo"
            />
          </div>
    
          <div className="quick-menu"> 
            <nav className="nav flex-column gap-1">
              <Link className="nav-link" title="Dashboard" to="/dashboard">
                <i className="material-icons-outlined">dashboard</i>
              </Link>
              <Link className="nav-link" title="Takeaway" to="/takeaway">
                <i className="material-icons-outlined">shopping_cart</i>
              </Link>
              <Link className="nav-link" title="Dining" to="/table">
                <i className="material-icons-outlined">poll</i>
              </Link>
              <Link className="nav-link" title="Menu" to="/item">
                <i className="material-icons-outlined">apps</i>
              </Link>
              
            </nav>
          </div>
    
          <div className="mini-footer dark-mode">
            <a href="/" className="footer-icon dark-mode-icon">
              <i className="fa fa-sign-out" aria-hidden="true"></i>
            </a>
          </div>
        </div>
  );
};

export default Asidde;
